exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".text-input{font-size:24px;padding:2px;position:relative;left:-2px;top:-1.05em;outline:none!important;border-bottom:1px solid hsla(0,0%,100%,.01);line-height:1.23em;display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./app/styles/text-input.css
// module id = 408
// module chunks = 0